import { z } from 'zod';

import { type IEndpointSchema, makeEndpoint } from '../common';

export const RearrangeCategoryRequestSchema = z
  .object({
    categoryIds: z.array(z.string().uuid()),
  })
  .extend({});

export const RearrangeCategoryEndpoint = makeEndpoint({
  method: 'PUT',
  url: ({ brandId }: { brandId: string }) => `brands/${brandId}/categories/rearrange`,
  responseSchema: z.void(),
  requestSchema: RearrangeCategoryRequestSchema,
});

export type IRearrangeCategoryEndpoint = IEndpointSchema<typeof RearrangeCategoryEndpoint>;
